import { render, staticRenderFns } from "./QuestionTypeTextYoutubeLink.vue?vue&type=template&id=ed31aefa"
import script from "./QuestionTypeTextYoutubeLink.vue?vue&type=script&lang=js"
export * from "./QuestionTypeTextYoutubeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports